var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomSelectComponent',{ref:"select",attrs:{"label":_vm.label,"labelCols":_vm.labelCols,"readOnly":_vm.readOnly,"readOnlyValue":_vm.readOnlyValue,"disabled":_vm.disabled,"rules":_vm.rules,"options":_vm.options,"value":_vm.value},on:{"input":(value) => _vm.$emit('input', value),"change":(value) => _vm.$emit('change', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }